export default[
    {
        path: '/dataList/salesTarget',
        component: resolve => require(['../page.vue'], resolve),
        meta: {
            title: '销售目标',
            authLogin: true
        }
    }
]